import { opacity } from '../../../lib/colourUtilities';
import theme from '../../../lib/theme';

const {
  scale,
  layouts,
  corners,
  colors,
  font: {
    spacings,
    families,
    heights,

    ...font
  },
} = theme;

export default () => ({
  container: {
    ...layouts.column,

    alignItems: 'flex-start',
    padding: `${scale.xs} ${scale.xxs}`,
    borderTop: `1px solid ${colors.light_grey}`,
    borderBottom: `1px solid ${colors.light_grey}`,
    background: opacity(colors['light_grey'], 70),
    borderRadius: corners.l,
  },

  label: {
    backgroundColor: 'transparent',
    color: colors.sas.primary,
    borderRadius: corners.s,
    fontSize: font.s,
    lineHeight: heights.s,
    fontFamily: families.primary,
    fontWeight: font.bold,
    letterSpacing: spacings.m,
  },

  title: {
    color: colors.black,
    fontSize: font.m,
    fontFamily: families.primary,
    fontWeight: font.bold,
    lineHeight: heights.m,
    letterSpacing: spacings.m,
    transition: 'all 150ms linear',
    maxWidth: 550,
  },

  byline: {
    color: colors.dark_grey,
    fontSize: font.s,
    fontFamily: families.primary,
    fontWeight: font.normal,
    lineHeight: heights.s,
    letterSpacing: spacings.m,
    marginBottom: 0,
  },

  bylineAuthor: {
    color: colors.black,
  },

  link: {
    textDecoration: 'none !important',

    '&:hover .InarticleRecirculation__title': {
      textDecoration: 'underline !important',
      color: colors.sas.primary,
    },
  },
});
